exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.search-bar-container{position:relative;display:inline-block}.search-bar-input-wrapper{position:relative;width:100%;height:100%}.search-bar-input{width:100%;height:100%;padding:8px 12px;padding-right:32px;border:1px solid #ddd;border-radius:4px;font-size:14px;font-family:Open Sans,sans-serif;color:#2c2c2c;background-color:#fff;box-sizing:border-box;transition:border-color .2s ease}.search-bar-input:focus{outline:none;border-color:#4a90e2;box-shadow:0 0 0 2px rgba(74,144,226,.1)}.search-bar-input:disabled{background-color:#f5f5f5;color:#999;cursor:not-allowed}.search-bar-input::placeholder{color:#999;font-style:italic}.search-bar-clear-button{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:20px;height:20px;border:none;background:none;color:#999;font-size:18px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:all .2s ease}.search-bar-clear-button:hover{background-color:#f0f0f0;color:#666}.search-bar-clear-button:disabled{cursor:not-allowed;color:#ccc}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/SearchBar/SearchBar.scss
// module id = 1617
// module chunks = 0